import { useState, useRef, useEffect } from "react";
import {
  Box,
  Input,
  InputGroup,
  InputLeftElement,
  Button,
  List,
  ListItem,
  Text,
  useOutsideClick
} from "@chakra-ui/react";
import { SearchIcon } from "../../utils/icons";

const CameraSearchSelect = ({ cameras, value, onChange, placeholder = "Selecione uma câmera" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCameras, setFilteredCameras] = useState(cameras);
  const ref = useRef();

  // Fechar quando clicar fora
  useOutsideClick({
    ref: ref,
    handler: () => setIsOpen(false),
  });

  // Filtrar câmeras baseado na busca
  useEffect(() => {
    if (!searchTerm) {
      setFilteredCameras(cameras);
    } else {
      const filtered = cameras.filter(camera =>
        camera.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        camera.id.toString().includes(searchTerm)
      );
      setFilteredCameras(filtered);
    }
  }, [searchTerm, cameras]);

  // Obter nome da câmera selecionada
  const getSelectedCameraName = () => {
    if (!value) return "";
    const camera = cameras.find(cam => cam.id.toString() === value.toString());
    return camera ? camera.name : "";
  };

  // Limpar seleção
  const clearSelection = () => {
    onChange({ target: { name: "cameraId", value: "" } });
    setSearchTerm("");
    setIsOpen(false);
  };

  return (
    <Box position="relative" ref={ref}>
      <InputGroup>
        <InputLeftElement pointerEvents="none">
          <SearchIcon color="gray.400" />
        </InputLeftElement>
        <Input
          placeholder={value ? getSelectedCameraName() : placeholder}
          value={isOpen ? searchTerm : (value ? getSelectedCameraName() : "")}
          onChange={(e) => setSearchTerm(e.target.value)}
          onFocus={() => setIsOpen(true)}
          cursor="pointer"
          readOnly={!isOpen}
        />
        {value && (
          <Button
            position="absolute"
            right="8px"
            top="50%"
            transform="translateY(-50%)"
            size="xs"
            variant="ghost"
            onClick={clearSelection}
            zIndex={2}
            color="gray.400"
            _hover={{ color: "gray.600" }}
          >
            ✕
          </Button>
        )}
      </InputGroup>

      {isOpen && (
        <Box
          position="absolute"
          top="100%"
          left={0}
          right={0}
          zIndex={1000}
          bg="white"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="md"
          boxShadow="lg"
          maxH="200px"
          overflowY="auto"
          mt={1}
        >
          <List spacing={0}>
            {filteredCameras.length === 0 ? (
              <ListItem p={3} color="gray.500" textAlign="center">
                Nenhuma câmera encontrada
              </ListItem>
            ) : (
              filteredCameras.map((camera) => (
                <ListItem
                  key={camera.id}
                  p={3}
                  cursor="pointer"
                  _hover={{ bg: "gray.100" }}
                  borderBottom="1px solid"
                  borderBottomColor="gray.100"
                  onClick={() => {
                    onChange({ target: { name: "cameraId", value: camera.id.toString() } });
                    setIsOpen(false);
                    setSearchTerm("");
                  }}
                >
                  <Text fontWeight="medium">{camera.name}</Text>
                  <Text fontSize="sm" color="gray.500">ID: {camera.id}</Text>
                </ListItem>
              ))
            )}
          </List>
        </Box>
      )}
    </Box>
  );
};

export default CameraSearchSelect;